import React from 'react';
import { Button, Modal, Space, Typography } from 'antd';
import { CloseOutlined, PhoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
  clearIncomingCallRing,
  storePendingAcceptCall,
  useIncomingCallRing,
} from '../../hooks/useIncomingCallRing';
import { callingService } from '../../services/callingService';

const { Text } = Typography;

const IncomingCallOverlay: React.FC = () => {
  const navigate = useNavigate();
  const { incomingCall, rejectIncomingCall } = useIncomingCallRing();

  if (!incomingCall) return null;

  const fromLabel = incomingCall.hostEmail ?? `User ${incomingCall.hostUserId}`;
  const title =
    incomingCall.type === 'group' ? 'Incoming group call' : 'Incoming call';

  const handleAccept = () => {
    const call = incomingCall;
    storePendingAcceptCall(call);
    // Join immediately while this page's signaling socket is live so the caller
    // leaves "Waiting to accept" without requiring a Call-page reload.
    const token = localStorage.getItem('token');
    if (token) callingService.connect(token);
    callingService.joinCall(call.callId);
    clearIncomingCallRing(call.callId);
    navigate('/call');
  };

  return (
    <Modal
      open
      centered
      closable={false}
      maskClosable={false}
      title={
        <Space>
          <PhoneOutlined />
          <span>{title}</span>
        </Space>
      }
      footer={
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button danger icon={<CloseOutlined />} onClick={rejectIncomingCall}>
            Decline
          </Button>
          <Button type="primary" icon={<PhoneOutlined />} onClick={handleAccept}>
            Accept
          </Button>
        </Space>
      }
    >
      <Text>
        From <Text strong>{fromLabel}</Text>
      </Text>
      <div style={{ marginTop: 8 }}>
        <Text type="secondary">
          Accept to open the Call page and connect. You can keep browsing until
          you answer or decline.
        </Text>
      </div>
    </Modal>
  );
};

export default IncomingCallOverlay;
